import { useMediaQuery } from 'react-responsive';
import { ILocation } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import LocationsTableItem from './LocationsTableItem';

const LocationsTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<ILocation[]>) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header, index) => !header ? null : (
          <span className={`head ${header.customClass}`} key={index}>
            {header.label}
          </span>
        ))}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item) => (
              <LocationsTableItem item={item} />
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default LocationsTableContainer;
